<!-- <h1 mat-dialog-title>Payments Terms
    <button mat-icon-button color="primary" class="subcSend" type="button" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
    </button>
</h1> -->
<div mat-dialog-content class="scroller">
    <h3 class="font-16 medium" >Please Enclose Cancelled Cheque</h3>
    <ul class="list-disc">
        <p>Kindly upload the cancelled cheque with the filled details</p>
    </ul>
    <div class="customUploader">
        <input id="module_profile_module_cancelled_cheque_dialog_1" #uploadFile type="file" #fileInput placeholder="Upload file..." (change)="fileSelect($event)" />
        <div>
            <button id="module_profile_module_cancelled_cheque_dialog_2" (click)="uploadFile.click()">
                Attach
            </button>
            <div *ngIf="file">
                {{file.name}}
                <span (click)="removeFile()">Delete</span>
            </div>
        </div>
      </div>
</div>
<div mat-dialog-actions>
    <button id="module_profile_module_cancelled_cheque_dialog_3" mat-button  class="btnCustom btn-primary" (click)="con();">Continue</button>
    <!-- <button mat-button class="btnCustom btn-primary" (click)="close(true)" *ngIf = "!isActivePaymentTerms" >I accept</button> -->
</div>